export const isMac = () => navigator.userAgentData.platform === 'macOS'
